/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Typography from "@insite/mobius/Typography"; // Store Custom Code
import * as React from "react";
import { connect } from "react-redux";

/* Store Custom Code - Start */
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { SPACING } from "@store/theme/common/design";
import { borderBottomTitlesStyles } from "@store/theme/common/mixins";
import polyfillCss from "@store/theme/common/polyfillCss";

const enum fields {
    hasBorderBottom = "hasBorderBottom",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.hasBorderBottom]: boolean;
    };
}
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

/* Store Custom Code - Start */
type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;
export interface PageTitleStyles {
    typography?: TypographyPresentationProps;
}

export const pageTitleStyle: PageTitleStyles = {
    typography: {
        variant: "h1",
        forwardAs: "h1",
        css: polyfillCss`
            margin-bottom: ${SPACING.small};

            &.has-border-bottom {
                ${borderBottomTitlesStyles()};
            }
        `,
    },
};
/* Store Custom Code - End */

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => {
    /* Store Custom Code - Start */
    const hasBorderBottomClass = fields.hasBorderBottom ? "has-border-bottom" : "";

    return (
        <Typography {...pageTitleStyle.typography} data-test-selector="PageTitle" className={hasBorderBottomClass}>
            {fields.overrideTitle || pageTitle}
        </Typography>
    );
    /* Store Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition: {
        group: "Basic",
        icon: "heading",
        // Store Custom Code
        fieldDefinitions: [
            {
                name: fields.hasBorderBottom,
                displayName: "Has border-bottom",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
